import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseResponse, BaseResponseDetail } from '../../interfaces/base-response/base-response.interface';
import { Consortia, Consortium, ConsortiumList, CreateConsortium } from '../../interfaces/consortium/consorcia.interface';
import { ConsortiumPartners } from '../../interfaces/consortium/user.interface';
import { Provider } from '../../interfaces/service/provider.interface';
import { fetchWithErrorHandling } from '../../utils/config/http.fetch.util';

@Injectable({
  providedIn: 'root'
})
export class ConsorciaService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  public consortiumId = new BehaviorSubject<string>('');
  public groupId = new BehaviorSubject<string>('');

  public getConsorcia(pageNumber: number, pageSize: number, criteria?: string): Observable<BaseResponse<ConsortiumList>> {
    let endpoint: string = `${this.apiUrl}/administrator/consortia?PageNumber=${pageNumber}&ItemsPerPage=${pageSize}`;

    if (criteria) {
      endpoint += `&Filter=groupId=${criteria}`;
    }

    return this.http.get<BaseResponse<ConsortiumList>>(endpoint);
  }

  public createConsortium(consortium: CreateConsortium): Observable<Consortium> {
    return this.http.post<Consortium>(`${this.apiUrl}/administrator/consortia`, consortium);
  }

  public updateConsortium(consortiumId: string, consortium: Consortium): Observable<Consortium> {
    return this.http.put<Consortium>(`${this.apiUrl}/administrator/consortia/${consortiumId}`, consortium);
  }

  public deleteConsortium(consortiumId: string): Observable<Consortium> {
    return this.http.delete<Consortium>(`${this.apiUrl}/administrator/consortia/${consortiumId}`);
  }

  public getConsortiumById(consortiumId: string): Observable<BaseResponseDetail<Consortium>> {
    let endpoint = `${this.apiUrl}/lottery/consortia/${consortiumId}/details`;

    return fetchWithErrorHandling<BaseResponseDetail<Consortium>>(endpoint, {
      method: 'GET',
      headers: {
        'Tenant': consortiumId,
        'Authorization': `Bearer ${localStorage.getItem('rbac-token')}`
      }
    });
  }

  public getConsortiumCurrentBalance(consortiumId: string): Observable<BaseResponseDetail<Provider>> {
    return this.http.get<BaseResponseDetail<Provider>>(`${this.apiUrl}/administrator/consortia/${consortiumId}/available-balance`);
  }

  public getConsortiumCurrentBalanceByProvider(consortiumId: string,providerApiId:string): Observable<BaseResponseDetail<Provider>> {
    return this.http.get<BaseResponseDetail<Provider>>(`${this.apiUrl}/administrator/provider-apis/${providerApiId}/consortium/${consortiumId}/balances`);
  }

  // LOTTERY

  public getGroupsByConsortiaId(consortiaId: string): Observable<BaseResponseDetail<Consortia>> {
    return this.http.get<BaseResponseDetail<Consortia>>(`${this.apiUrl}/lottery/consortia/${consortiaId}`);
  }

  // PARTNERS

  public getPartners(
    id: string,
    pageNumber: number,
    pageSize: number,
    name?: string
  ): Observable<BaseResponse<ConsortiumPartners>> {
    let endpoint = `${this.apiUrl}/lottery/consortia/${id}/allied-consortia?PageNumber=${pageNumber}&ItemsPerPage=${pageSize}`;
    if (name) {
      endpoint += `&Filter=name%3D${encodeURIComponent(name)}`;
    }

    return fetchWithErrorHandling<BaseResponse<ConsortiumPartners>>(endpoint, {
      method: 'GET',
      headers: {
        'Tenant': id,
        'Authorization': `Bearer ${localStorage.getItem('rbac-token')}`
      }
    });
  }

  public createPartner(
    id: string,
    partner: any
  ): Observable<BaseResponse<ConsortiumPartners>> {
    return fetchWithErrorHandling<BaseResponse<ConsortiumPartners>>(
      `${this.apiUrl}/lottery/consortia/${id}/allied-consortia`,
      {
        method: 'POST',
        headers: {
          'Tenant': id,
          'Authorization': `Bearer ${localStorage.getItem('rbac-token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(partner)
      }
    );
  }

  public changeStatusPartner(
    id: string,
    alliedId: string,
    status: number
  ): Observable<BaseResponse<ConsortiumPartners>> {
    return fetchWithErrorHandling<BaseResponse<ConsortiumPartners>>(
      `${this.apiUrl}/lottery/consortia/${id}/allied-consortia/${alliedId}/change-status`,
      {
        method: 'PUT',
        headers: {
          'Tenant': id,
          'Authorization': `Bearer ${localStorage.getItem('rbac-token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status })
      }
    );
  }
}
